import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { store } from './store/store';
import { Route, Routes } from 'react-router-dom';
import 'styles/_variables.scss';
import 'styles/_mixin.scss';
import 'styles/reset.scss';
import 'styles/tailwind.css';
import 'styles/font.css';
import 'styles/global.scss';
import 'styles/common.scss';
import 'pages/company-view/company-view.scss';
import 'components/common/common.scss';
import MainLayout from './components/layout/MainLayout';
import { ThemeProvider } from './context/ThemeContext';
import Auth from './utils/auth';
import useNativeMessaging from '@/hooks/useNativeMessaging';
import axios from 'axios';
import ProtectedRoute from './components/common/ProtectedRoute';
import NotFound from '@/components/common/NotFound';
import { ToastProvider } from '@/context/ToastContext';
const CompanyView = lazy(() => import('pages/company-view/CompanyView'));
const Conversation = lazy(() => import('pages/conversation/Conversation'));
const Login = lazy(() => import('pages/login/Login'));
const ComchatLab = lazy(() => import('pages/comchat-lab/ComchatLab'));
const BusinessCardDetail = lazy(() => import('pages/business-card-detail/BusinessCardDetail'));
const BusinessCardEdit = lazy(() => import('pages/business-card-edit/BusinessCardEdit'));
const BusinessCardList = lazy(() => import('pages/business-card-list/BusinessCardList'));
const BusinessCardLoading = lazy(() => import('pages/business-card-loading/BusinessCardLoading'));
const BusinessCardBookmarkList = lazy(() => import('pages/business-card-bookmark-list/BusinessCardBookmarkList'));
const BusinessCardCalendar = lazy(() => import('pages/business-card-calendar/BusinessCardCalendar'));
const Share = lazy(() => import('pages/share/Share'));
const StatDetail = lazy(() => import('pages/stat-detail/StatDetail'));
const StatCategory = lazy(() => import('pages/stat-category/StatCategory'));
const StatMain = lazy(() => import('pages/stat-main/StatMain'));
const ComchatLabIndustrySearch = lazy(() => import('pages/comchat-lab-industry-search/ComchatLabIndustrySearch'));
const ComchatLabCategorySearch = lazy(() => import('pages/comchat-lab-catetory-search/ComchatLabCategorySearch'));

// const api = axios.create({
//     baseURL: process.env.REACT_APP_API_URL,
//     // ...기타 설정
// });

// api.interceptors.response.use(
//     response => response,
//     error => {
//         const message = error?.response?.data?.message || '';
//         console.log('message', error?.response);

//         // 메시지에 jwt/token 관련 키워드가 포함되어 있으면 RN으로 실패 메시지 전송
//         if (
//             typeof message === 'string' &&
//             (message.toLowerCase().includes('jwt') || message.toLowerCase().includes('token'))
//         ) {
//             if (window.ReactNativeWebView) {
//                 window.ReactNativeWebView.postMessage(
//                     JSON.stringify({
//                         from: 'SET_TOKEN_FAIL',
//                         message: 'fail',
//                     })
//                 );
//             }
//         }
//         return Promise.reject(error);
//     }
// );

function App() {
    function setScreenSize() {
        const vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    useEffect(() => {
        setScreenSize();

        window.addEventListener('resize', setScreenSize); // resize 이벤트 리스너 추가

        return () => {
            window.removeEventListener('resize', setScreenSize); // cleanup
        };
    }, []); // 빈 의존성 배열로 변경

    // useEffect(() => {
    //     // window.addEventListener('authTokenSet', () => {
    //     //     const token = localStorage.getItem('token');
    //     //     Auth.login(token);
    //     // });
    //     if (window.location.pathname === '/login') {
    //         return;
    //     }
    //     const isLoggedIn = Auth.isLoggedIn();
    //     if (!isLoggedIn) {
    //         window.location.href = '/login';
    //     }
    // }, []);

    // useEffect(() => {
    //     const token = window.tokenFromRN || localStorage.getItem("authToken");
    //     if (token) {
    //       console.log("받은 토큰:", token);
    //       Auth.login(token);
    //       window.location.href = '/';
    //     }
    // }, []);

    return (
        <Provider store={store}>
            <ThemeProvider>
                <ToastProvider>
                    <MainLayout>
                        <Suspense>
                            <Routes>
                                {/* 공개 페이지 */}

                                {/* 개발 모드 또는 웹뷰 내 허용 페이지 */}
                                <Route
                                    path="/"
                                    element={
                                        <ProtectedRoute>
                                            <Conversation />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route path="/share/:shareId" element={<Share />} />
                                <Route
                                    path="/login"
                                    element={
                                        <ProtectedRoute>
                                            <Login />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/company-view/:companyId"
                                    element={
                                        <ProtectedRoute>
                                            <CompanyView />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/comchat-lab"
                                    element={
                                        <ProtectedRoute>
                                            <ComchatLab />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/stat-detail"
                                    element={
                                        <ProtectedRoute>
                                            <StatDetail />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/stat-category"
                                    element={
                                        <ProtectedRoute>
                                            <StatCategory />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/stat-main"
                                    element={
                                        <ProtectedRoute>
                                            <StatMain />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-list"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardList />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-bookmark-list"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardBookmarkList />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-detail/:businessCardId"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardDetail />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-edit/:businessCardId"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardEdit />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-loading"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardLoading />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/business-card-calendar"
                                    element={
                                        <ProtectedRoute>
                                            <BusinessCardCalendar />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/comchat-lab-industry-search"
                                    element={
                                        <ProtectedRoute>
                                            <ComchatLabIndustrySearch />
                                        </ProtectedRoute>
                                    }
                                />
                                <Route
                                    path="/comchat-lab-category-search"
                                    element={
                                        <ProtectedRoute>
                                            <ComchatLabCategorySearch />
                                        </ProtectedRoute>
                                    }
                                />

                                {/* 그 외 모든 경로 */}
                                <Route path="*" element={<NotFound />} />
                            </Routes>
                        </Suspense>
                    </MainLayout>
                </ToastProvider>
            </ThemeProvider>
        </Provider>
    );
}

export default App;
